import React from 'react';
import { useQueries } from '@tanstack/react-query';
import readAWSS3File from 'utils/readAWSS3File';
import { isEmpty } from 'ramda';
import { getFileNameFromURL } from 'utils/utils';
import Icon from 'components/Icon/Icon';
import Modal from '../Modal';

type PhotoPreviewerProps = {
  photos: string[];
  onCloseModal: () => void;
};

function PhotoPreviewer({ photos, onCloseModal }: PhotoPreviewerProps) {
  const photoQueries = useQueries({
    queries: photos
      .filter(fndPhoto => fndPhoto && !isEmpty(fndPhoto))
      .map(fndPhoto => {
        const photoKey = getFileNameFromURL(fndPhoto);
        return {
          queryKey: ['photo', photoKey],
          queryFn: () => readAWSS3File('document', fndPhoto),
        };
      }),
  });

  const photosLoading = photoQueries.some(fndPhoto => fndPhoto.isLoading);

  return (
    <Modal onClose={onCloseModal} show>
      <div className="rounded-xl bg-white tablet:w-[750px]">
        <div className="flex flex-col p-6 pt-6 pb-8">
          <h3 className="text-river-black text-[20px] font-semibold">Patient ID & Selfie</h3>
          <div className="flex flex-col space-y-2 tablet:flex-row tablet:space-y-0 tablet:space-x-5 mt-[30px]">
            {photosLoading ? (
              <div className="relative flex flex-col items-center justify-center w-full h-[220px]">
                <Icon id="loader" className="w-10 inline-flex" />
              </div>
            ) : (
              photoQueries.map((fndPhoto, index) => (
                <div className="flex flex-col items-center justify-center w-full" key={index}>
                  <div
                    className="w-full rounded-xl border-2 border-dashed border-river-blue h-[220px] bg-[#EDF9FF] 
                      mb-2 flex flex-col justify-center"
                  >
                    <a
                      href={fndPhoto.data}
                      className="overflow-hidden h-[180px] w-fit mx-auto cursor-pointer block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="w-full h-full object-cover"
                        src={fndPhoto.data}
                        alt={`preview ${index}`}
                      />
                    </a>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default PhotoPreviewer;
